import { TruktTmsApi } from '@trukt/tms-api/TruktTmsApi';

export const truktTmsApi = new TruktTmsApi({
  baseURL: import.meta.env.VITE_TRUKT_API_BASE_URL,
});
